import PropTypes from 'prop-types';
import React from 'react';
import { Container, Image, Menu, Icon, Button } from 'semantic-ui-react';
import * as styles from './NavBar.less';
import logo from 'resources/logo.png';
import logoBlack from 'resources/logo-black.png';
// import ojkLogo from 'resources/OJKLogo.png'
// import ojkLogoWhite from 'resources/OJKLogoWhite.png'
import NavBarMenu from './NavBarMenu';
import LocaleToggle from '../LocaleToggle';
import NavBarButtonMenu from './NavBarButtonMenu';
import { compose } from 'redux';
import { changeRedirectState } from '../../redux/global/redirect/actions';
import { push } from 'connected-react-router/immutable';
import { createStructuredSelector } from 'reselect';
import { makeRedirectUrl } from '../../redux/global/redirect/selector';
import connect from 'react-redux/es/connect/connect';

class NavBarDesktop extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      currentScrollHeight: 0
    };
  }

  componentDidMount() {
    window.onscroll = () => {
      const newScrollHeight = Math.ceil(window.scrollY / 50) * 50;
      if (this.state.currentScrollHeight !== newScrollHeight) {
        this.setState({ currentScrollHeight: newScrollHeight });
      }
    };
  }

  render() {
    const opacity = Math.min(100 / this.state.currentScrollHeight, 1);
    const showNavbar = opacity < 0.8;
    const navbarLocation = window.location.pathname == '/';

    const menuListDesktop = this.props.leftItems;
    const navbarListDesktop = menuListDesktop.slice(1);

    return (
      <Menu
        borderless
        fixed="top"
        pointing={!showNavbar && navbarLocation}
        inverted={!showNavbar && navbarLocation}
        className={styles.container}
      >
        <Container fluid>
          <Menu.Item
            className={
              !showNavbar && navbarLocation
                ? styles.menuContainer
                : styles.itemContainer
            }
            onClick={() => this.props.handleItemClick('/', '')}
          >
            <Image
              size="tiny"
              src={logo}
              className={styles.topLeftNavbarLogo}
            />
          </Menu.Item>

          <Menu.Menu position="right" className={styles.menuContainer}>
            <NavBarMenu menuList={navbarListDesktop} />
            <NavBarButtonMenu buttonList={this.props.rightItems} />
            <Menu.Item>
              <LocaleToggle />
            </Menu.Item>
            <Menu.Item>
              <Menu.Item>
                <Button id={'tkbButton'} onClick={this.props.onTkb}>
                  TKB90 : 95%
                  <Icon name="info circle" style={{ paddingLeft: '15px' }} />
                </Button>
              </Menu.Item>
            </Menu.Item>
          </Menu.Menu>
        </Container>
      </Menu>
    );
  }
}

NavBarDesktop.propTypes = {
  leftItems: PropTypes.arrayOf(PropTypes.object),
  rightItems: PropTypes.arrayOf(PropTypes.object),
  handleItemClick: PropTypes.func,
  onTkb: PropTypes.func
};

export function mapDispatchToProps(dispatch) {
  return {
    handleItemClick: (href, redirect) => {
      if (redirect) {
        dispatch(changeRedirectState(redirect));
      }
      dispatch(push(href));
      window.scrollTo(0, 0);
    }
  };
}

const mapStateToProps = createStructuredSelector({
  redirectState: makeRedirectUrl()
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(withConnect)(NavBarDesktop);



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBarDesktop.js